import { render, staticRenderFns } from "./editDepositTier.vue?vue&type=template&id=5e79690c&lang=pug"
import script from "./editDepositTier.vue?vue&type=script&lang=js"
export * from "./editDepositTier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports